import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { logoutflow, checkAuth } from '@/utils/authenticated'
import { ElMessageBox } from 'element-plus'
import { UserGettersTypes } from '@/store/modules/user'
import { getPermissionByItem, getPagePermission, PermissionsItem, PermissionsAction } from '@/utils/permission'
import store from '@/store'
import { getLocaleText } from '@/utils/tools'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('../views/layout/Main.vue'),
    meta: {
      menuName: 'HOMEPAGE',
      menuindex: 0,
      icon: 'HomeFilled',
      sidemenu: true
    },
    children: [
      {
        path: '',
        name: 'Home',
        meta: {
          menuName: 'HOMEPAGE',
          sidemenu: true,
          isTop: true
        },
        component: () => import('../views/index.vue')
      }
    ]
  },
  {
    path: '/user',
    component: () => import('../views/layout/Main.vue'),
    meta: {
      menuName: 'SYSTEM_MANAGEMENT',
      menuindex: 6,
      icon: 'Setting',
      sidemenu: true,
      auth: 'roles'
    },
    children: [
      {
        path: 'index',
        name: 'supplierInfo',
        meta: {
          menuName: 'SUPPLIER_INFO',
          sidemenu: true
        },
        component: () => import('../views/user/index.vue')
      },
      {
        path: 'loginRecord',
        name: 'loginRecord',
        meta: {
          menuName: 'SIGN_IN_RECORD',
          sidemenu: true
        },
        component: () => import('../views/user/LoginRecord.vue')
      },
      {
        path: 'activityRecord',
        name: 'activityRecord',
        meta: {
          menuName: 'ACTIVITY_RECORD',
          sidemenu: true
        },
        component: () => import('../views/user/ActivityRecord.vue')
      },
      {
        path: 'setting',
        name: 'setting',
        meta: {
          menuName: 'ACCOUNT_SETTING',
          sidemenu: true
        },
        component: () => import('../views/user/setting.vue')
      }
    ]
  },
  {
    path: '/user/login',
    name: 'Login',
    component: () => import('../views/user/login.vue')
  },
  {
    path: '/user/forgetPassword',
    name: 'forgetPassword',
    component: () => import('../views/user/forgetPassword.vue')
  },
  {
    path: '/user/resetPassword/:token',
    name: 'resetPassword',
    component: () => import('../views/user/resetPassword.vue')
  },
  {
    path: '/product',
    component: () => import('../views/layout/Main.vue'),
    meta: {
      menuName: 'PRODUCT_MANAGEMENT',
      menuindex: 1,
      icon: 'Goods',
      sidemenu: true
    },
    children: [
      {
        path: 'index',
        name: 'ProducatIndex',
        meta: {
          menuName: 'PRODUCT_LIST',
          sidemenu: true,
          authName: PermissionsItem.products,
          requireAuthAction: [PermissionsAction.read]
        },
        component: () => import('../views/product/index.vue')
      },
      // {
      //   path: 'gdsindex',
      //   name: 'GDSProducatIndex',
      //   meta: { menuName: '原GDS商品管理', sidemenu: true, auth: 'GDSproduct' },
      //   component: () => import('../views/product/gdsindex.vue')
      // },
      {
        path: 'add',
        name: 'AddProduct',
        meta: {
          menuName: 'ADD_PRODUCT',
          sidemenu: false,
          authName: PermissionsItem.products,
          requireAuthAction: [PermissionsAction.create],
          breadcrumbs: [
            {
              title: 'PRODUCT_LIST',
              pathName: 'ProducatIndex'
            }
          ]
        },
        component: () => import('../views/product/add.vue')
      },
      {
        path: 'edit/:id',
        name: 'EditProduct',
        meta: {
          menuName: 'EDIT_PRODUCT',
          sidemenu: false,
          authName: PermissionsItem.products,
          requireAuthAction: [PermissionsAction.update],
          breadcrumbs: [
            {
              title: 'PRODUCT_LIST',
              pathName: 'ProducatIndex'
            }
          ]
        },
        component: () => import('../views/product/add.vue')
      },
      {
        path: 'exceladd',
        name: 'ExcelAdd',
        meta: {
          menuName: 'ADD_PRODUCT',
          sidemenu: false,
          authName: PermissionsItem.products,
          requireAuthAction: [PermissionsAction.create],
          breadcrumbs: [
            {
              title: 'PRODUCT_LIST',
              pathName: 'ProducatIndex'
            }
          ]
        },
        component: () => import('../views/product/exceladdproduct.vue')
      },
      {
        path: 'detail/:id?',
        name: 'Detail',
        meta: {
          menuName: 'PRODUCT_INFO',
          sidemenu: false,
          authName: PermissionsItem.products,
          requireAuthAction: [PermissionsAction.read],
          breadcrumbs: [
            {
              title: 'PRODUCT_LIST',
              pathName: 'ProducatIndex'
            }
          ]
        },
        component: () => import('../views/product/detail.vue')
      }
    ]
  },
  {
    path: '/accounting',
    component: () => import('../views/layout/Main.vue'),
    meta: {
      menuName: 'RECONCILIATION_MANAGEMENT',
      menuindex: 3,
      icon: 'money',
      sidemenu: true
    },
    children: [
      {
        path: 'index',
        name: 'AccountingIndex',
        meta: {
          menuName: 'RECONCILIATION_LIST',
          sidemenu: true,
          authName: PermissionsItem.reconciliations,
          requireAuthAction: [PermissionsAction.read]
        },
        component: () => import('../views/accounting/index.vue')
      }
    ]
  },
  {
    path: '/order',
    component: () => import('../views/layout/Main.vue'),
    meta: {
      menuName: 'ORDER_MANAGEMENT',
      menuindex: 2,
      icon: 'Document',
      sidemenu: true
    },
    children: [
      {
        path: 'index',
        name: 'OrderIndex',
        meta: {
          menuName: 'ORDER_LIST',
          sidemenu: true,
          authName: PermissionsItem.orders,
          requireAuthAction: [PermissionsAction.read]
        },
        component: () => import('../views/order/index.vue')
      },
      {
        path: 'detail/:id',
        name: 'OrderDetail',
        meta: {
          menuName: 'ORDER_INFO',
          sidemenu: false,
          authName: PermissionsItem.orders,
          requireAuthAction: [PermissionsAction.read],
          breadcrumbs: [
            {
              title: 'ORDER_LIST',
              pathName: 'OrderIndex'
            }
          ]
        },
        component: () => import('../views/order/detail.vue')
      },
      {
        path: 'certificate',
        name: 'OrderCertificate',
        meta: {
          menuName: 'VOUCHER_LIST',
          sidemenu: true,
          authName: PermissionsItem.vouchers,
          requireAuthAction: [PermissionsAction.read]
        },
        component: () => import('../views/order/ordercertificate.vue')
      }
    ]
  },
  {
    path: '/analysis',
    component: () => import('../views/layout/Main.vue'),
    meta: {
      menuName: 'DATA_CENTER',
      menuindex: 5,
      icon: 'Histogram',
      sidemenu: false
    },
    children: [
      {
        path: 'index',
        name: 'AnalysisIndex',
        meta: {
          menuName: 'OPERATE_PERFORMANCE',
          sidemenu: true
        },
        component: () => import('../views/analysis/index.vue')
      }
    ]
  },
  {
    path: '/store',
    component: () => import('../views/layout/Main.vue'),
    meta: {
      menuName: 'MERCHANT_MANAGEMENT',
      menuindex: 4,
      icon: 'House',
      sidemenu: true,
      auth: 'store'
    },
    children: [
      {
        path: 'merchant',
        name: 'merchant',
        meta: {
          menuName: 'MERCHANT_LIST',
          sidemenu: true,
          authName: PermissionsItem.merchants,
          requireAuthAction: [PermissionsAction.read]
        },
        component: () => import('../views/store/MerchantManagement.vue')
      },
      {
        path: 'branch',
        name: 'branch',
        meta: {
          menuName: 'BRANCH_LIST',
          sidemenu: true,
          authName: PermissionsItem.branches,
          requireAuthAction: [PermissionsAction.read]
        },
        component: () => import('../views/store/BranchManagement.vue')
      },
      // {
      //   path: 'storeAccount',
      //   name: 'storeAccount',
      //   meta: {
      //     menuName: '分店帳號管理',
      //     sidemenu: true,
      //     auth: 'storeAccount'
      //   },
      //   component: () => import('../views/store/CreatAccount.vue')
      // },
      {
        path: 'roles',
        name: 'RolesIndex',
        meta: {
          menuName: 'MENU_PERMISSION_MANAGEMENT',
          sidemenu: false
        },
        component: () => import('../views/roles/index.vue')
      },
      {
        path: 'add',
        name: 'storeadd',
        meta: {
          menuName: 'ADD_BRANCH',
          sidemenu: false,
          authName: PermissionsItem.branches,
          requireAuthAction: [PermissionsAction.create],
          breadcrumbs: [
            {
              title: 'BRANCH_LIST',
              pathName: 'branch'
            }
          ]
        },
        component: () => import('../views/store/add.vue')
      },
      {
        path: 'addmerchants',
        name: 'storeaddmerchants',
        meta: {
          menuName: 'ADD_MERCHANT',
          sidemenu: false,
          authName: PermissionsItem.merchants,
          requireAuthAction: [PermissionsAction.create],
          breadcrumbs: [
            {
              title: 'MERCHANT_LIST',
              pathName: 'merchant'
            }
          ]
        },
        component: () => import('../views/store/addmerchants.vue')
      },
      {
        path: 'addexcel',
        name: 'storeaddexcel',
        meta: {
          menuName: 'CREATE_MERCHANT_BATCH',
          sidemenu: false,
          authName: PermissionsItem.merchants,
          requireAuthAction: [PermissionsAction.create]
        },
        component: () => import('../views/store/exceladdstore.vue')
      }
    ]
  },
  {
    path: '/redirect/:token?',
    name: 'redirectAuth',
    component: () => import('../views/redirect/index.vue')
  },
  {
    path: '/forbidden',
    component: () => import('../views/layout/Forbidden.vue'),
    name: 'forbidden'
  },
  {
    path: '/error',
    component: () => import('../views/layout/error.vue'),
    name: 'Error'
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/error'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from) => {
  // 不用檢查 token 的頁面
  const noVerificationPages = ['Login', 'forgetPassword', 'resetPassword', 'redirectAuth', 'forbidden']
  const pageName = to.name || ''

  // 要檢查token的頁面
  if (!noVerificationPages.includes(pageName as string)) {
    // 檢查 token
    if (!checkAuth()) {
      logoutflow()
      return { path: '/user/login' }
    }

    // 檢查路由權限 check router permission
    const requireAuthAction = to.meta.requireAuthAction || [] // 要求的權限動作
    const pagePermisstion = getPagePermission(to.meta?.authName as string, requireAuthAction as Array<string>) // 頁面權限

    // 若無權限，導首頁 (權限名稱authName, 需要的權限requireAuthAction as Array [])
    if ('authName' in to.meta && !pagePermisstion) {
      return { path: '/' }
    }
  } else {
    // 跳轉頁 & 無權限
    if (pageName === 'redirectAuth' || pageName === 'forbidden') {
      return
    }

    // 不用檢查token的頁面 > 若已登入, 導首頁
    if (checkAuth()) {
      return { path: '/' }
    }
  }
})

export default router
